import { Switch } from "antd";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useWorldMap } from "../../../../../contexts/WorldMapContext";
import { inside } from "../../../../../contexts/WorldMapContext/constants";
import { DiseaseZonePolygon } from "../../../../../contexts/WorldMapContext/Polygon";
import { BarentsWatchService } from "../../../../../util/barentswatch/api";
import { datetime } from "../../../../../util/library/datetime";
import { selectOneSetting, selectViewMode } from "../../../../../util/store/selectors";
import { DISEASED_ZONE, diseasedZone } from "../../../../../util/varibles/constants";
import { convertDisease } from "../../../../../util/varibles/global";
import { VIEW_MODE } from "../../../../../util/varibles/permission";
import { DashboardSetting } from "../../../../../util/varibles/userSetting";
import { loginActions } from "../../../../LoginPage/reducer";
import styles from "../../style.module.scss";

interface IPropsDiseasedZone {
    source: any[],
    type: DISEASED_ZONE
}

const DiseasedZoneHover: React.FC<IPropsDiseasedZone> = ({ source, type }) => {
    const [location, setStore] = useWorldMap(state => state.location);

    useEffect(() => {
        if (location) {
            setStore(prev => ({
                zones: {
                    ...prev.zones,
                    [type]: source.filter(item => inside(location, item.coordinates[0]))
                }
            }))
        }

        return () => {
            setStore(prev => ({ zones: { ...prev.zones, [type]: [] } }))
        }
    }, [location, setStore, source, type]);

    return null
}


interface IProps {
    data: { id: DISEASED_ZONE, name: string },
    showControl?: boolean
}

const DiseasedZone: React.FC<IProps> = (props) => {
    const { id, name } = props.data;
    const {showControl = true} = props;
    const viewMode = useSelector(selectViewMode)
    const filter = useSelector(selectOneSetting(DashboardSetting.DISEASED_ZONE))

    const dispatch = useDispatch();
    const [{ week, zones, loading }, setZones] = useState<{ week?: string, zones: any[], loading: boolean }>({
        zones: [],
        loading: false
    });

    useEffect(() => {
        const weekNew = [datetime().year, datetime().week].join('/');
        if (weekNew !== week) {
            setZones(prev => ({ ...prev, week: weekNew, loading: true }))
            BarentsWatchService.getIlaControlAreaV2(id, weekNew)
                .then((rs: any) => {
                    const zones = rs.map((item: any) => convertDisease(item));
                    setZones(prev => ({ ...prev, zones, loading: false }))
                })
                .catch(() => {
                    setZones(prev => ({ ...prev, loading: false }))
                })
        }
    }, [id, week]);

    const onChange = (checked: boolean) => {
        const value = { ...filter, [id]: checked };
        dispatch(loginActions.updateUserSetting([{ [DashboardSetting.DISEASED_ZONE]: value }]));
    }

    const { color = '' } = diseasedZone[id] || {};
    const style: any = { '--diseased-color': color };
    const checked = filter[id] ?? true;
    const visible = viewMode === VIEW_MODE.VESSEL || checked;

    const polygons = <>
        {zones.map(item => <DiseaseZonePolygon
            key={item.id}
            data={item}
            show={visible}
            diseaseType={id}
        />)}
        {visible && <DiseasedZoneHover source={zones} type={id} />}
    </>;

    if (!showControl)
        return polygons;

    return <div key={id} className={styles.line} style={style}>
        <div className={styles.diseasedLine}>
            <div className='diseased-zone' data-code={id} />
            <div className='text-[15px]'>{name}</div>
        </div>
        <Switch
            loading={loading}
            checked={filter[id]}
            onChange={(checked) => onChange(checked)}
        />
        {polygons}
    </div>
};

export default DiseasedZone;
